module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/alloted-property-list/alloted-property-list.component.css
// module id = ./src/app/allocation/alloted-property-list/alloted-property-list.component.css
// module chunks = main